import { render, staticRenderFns } from "./WalletSelector.vue?vue&type=template&id=ebfcab8c&"
import script from "./WalletSelector.vue?vue&type=script&lang=js&"
export * from "./WalletSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports